import { bl_fi_slsodr_to_slsinv_consol_event_hdr_RowClass } from "../../dbschema/bl_fi_slsodr_to_slsinv_consol_event_hdr.model";
import { BaseContainerModel } from "../base-container.model";

export class SOConsolidationEventModel extends BaseContainerModel {
  bl_fi_slsodr_to_slsinv_consol_event_hdr: bl_fi_slsodr_to_slsinv_consol_event_hdr_RowClass =
    new bl_fi_slsodr_to_slsinv_consol_event_hdr_RowClass();
}
